<po-page-list
  p-title="Modulo de Entrada NFs - Notas Entregues"
  [p-actions]="pageActions"
  [p-filter]="filterSettings">
  <div style="display: flex; justify-content: flex-end; margin-bottom: 8px; gap: 8px">
    <po-button
    p-icon="an an-funnel-x"
    p-label="Limpar Filtros"
    [p-disabled]="!hasActiveFilters"
    (p-click)="clearAdvancedFilter()">
    </po-button>
    <po-button
      p-kind="primary"
      p-icon="an an-funnel"
      p-label="Filtros"
      (p-click)="advancedFilterAction()">
    </po-button>
  </div>

  <po-loading-overlay [hidden]="!isLoading"></po-loading-overlay>

  <po-table
    [p-columns]="columns"
    [p-items]="notasFiltered"
    [p-actions]="tableActions"
    [p-sort]="true"
    [p-striped]="true"
    [p-height]="tableHeight"
    [p-loading]="loadingMore"
    [p-show-more-disabled]="!hasMore"
    (p-show-more)="carregarMais()">
  </po-table>

</po-page-list>

<po-modal
  #reprovarModal
  p-title="Reprovar nota fiscal"
  [p-primary-action]="modalReprovarConfirma"
  [p-secondary-action]="modalReprovarCancela">

  <po-loading-overlay *ngIf="reprovando" p-text="Excluindo..."></po-loading-overlay>

  <p *ngIf="notaParaReprovar" class="po-font-text">
    Tem certeza que deseja reprovar a nota
    <strong>{{ notaParaReprovar.numero }}</strong>
    do fornecedor <strong>{{ notaParaReprovar.fornecedor }}</strong>?
  </p>
  <p class="po-font-text-small" style="color: #c0392b; margin-top: 8px;">
    Esta acao exclui SF1 + SD1 e movimentos vinculados (MATA103 op 5).
    Nao podera ser desfeita pelo portal.
  </p>

  <div class="po-row" style="margin-top: 12px;">
    <po-input
      class="po-md-12"
      p-label="Motivo (opcional)"
      [(ngModel)]="motivoReprovacao"
      [ngModelOptions]="{standalone: true}"
      [p-maxlength]="200"
      p-placeholder="Ex: divergencia de valor, fornecedor errado, etc.">
    </po-input>
  </div>
</po-modal>

<po-modal
  #reprocCnxModal
  p-title="Reprocessar no Conexos"
  [p-primary-action]="modalReprocCnxConfirma"
  [p-secondary-action]="modalReprocCnxCancela">

  <po-loading-overlay *ngIf="reprocessandoCnx" p-text="Enviando ao Conexos..."></po-loading-overlay>

  <div *ngIf="notaReprocCnx">
    <p class="po-font-text">
      Reenviar ao Conexos a nota
      <strong>{{ notaReprocCnx.numero }}</strong>
      <span *ngIf="notaReprocCnx.serie"> / {{ notaReprocCnx.serie }}</span>
      do fornecedor <strong>{{ notaReprocCnx.fornecedor }}</strong>?
    </p>
    <p class="po-font-text-small" *ngIf="notaReprocCnx.processo">
      Processo: <strong>{{ notaReprocCnx.processo }}</strong>
    </p>
    <p class="po-font-text-small" *ngIf="notaReprocCnx.cnxStatusDes">
      Situação atual: <strong>{{ notaReprocCnx.cnxStatusDes }}</strong>
      <span *ngIf="notaReprocCnx.cnxTentativa"> (tentativas: {{ notaReprocCnx.cnxTentativa }})</span>
    </p>
    <p class="po-font-text-small" *ngIf="notaReprocCnx.cnxMsg" style="color: #c0392b; margin-top: 8px;">
      Último retorno: {{ notaReprocCnx.cnxMsg }}
    </p>
    <p class="po-font-text-small" style="margin-top: 8px;">
      O envio acontece agora, sem esperar o próximo ciclo. Um documento já criado
      no Conexos é reaproveitado - o reprocesso não gera documento duplicado.
    </p>

    <p class="po-font-text-small" *ngIf="reprocCnxResultado" style="margin-top: 12px;"
       [style.color]="reprocCnxOk ? '#1a7f37' : '#c0392b'">
      {{ reprocCnxResultado }}
    </p>
  </div>
</po-modal>

<po-modal
  #reanexoModal
  p-title="Anexar documentos"
  p-size="md"
  [p-primary-action]="modalReanexoConfirma"
  [p-secondary-action]="modalReanexoCancela">

  <po-loading-overlay *ngIf="reanexoEnviando" p-text="Enviando..."></po-loading-overlay>

  <div class="po-row" *ngIf="notaReanexo">
    <p class="po-font-text-small po-md-12">
      NF {{ notaReanexo.numero }} - {{ notaReanexo.fornecedor }}
    </p>

    <po-select
      class="po-md-12"
      name="reanexoGedFolder"
      p-label="Pasta GED"
      [p-options]="reanexoGedOptions"
      [ngModel]="reanexoGedFolder"
      (p-change)="reanexoGedFolder = $event"
      [ngModelOptions]="{standalone: true}">
    </po-select>

    <div class="anexos po-md-12">
      <div class="anexo-slot"
           [class.anexo-slot--drag]="reanexoDanfeDrag"
           (dragover)="onReanexoSlotDragOver($event, 'danfe')"
           (dragleave)="onReanexoSlotDragLeave($event, 'danfe')"
           (drop)="onReanexoSlotDrop($event, 'danfe')">
        <span class="anexo-slot__label">DANFE / CTe (PDF)</span>
        <label class="anexo-slot__btn">
          <span class="po-icon an an-paperclip"></span>
          <span class="anexo-slot__btn-text">
            {{ reanexoDanfe ? reanexoDanfe.name : 'Selecionar ou arraste aqui' }}
          </span>
          <input
            type="file"
            accept=".pdf,application/pdf"
            (change)="onReanexoFile('danfe', $event)"
            hidden>
        </label>
        <a *ngIf="reanexoDanfe" class="anexo-slot__clear" (click)="clearReanexoFile('danfe')">Remover</a>
      </div>

      <div class="anexo-slot"
           [class.anexo-slot--drag]="reanexoBoletoDrag"
           (dragover)="onReanexoSlotDragOver($event, 'boleto')"
           (dragleave)="onReanexoSlotDragLeave($event, 'boleto')"
           (drop)="onReanexoSlotDrop($event, 'boleto')">
        <span class="anexo-slot__label">Boleto (PDF)</span>
        <label class="anexo-slot__btn">
          <span class="po-icon an an-paperclip"></span>
          <span class="anexo-slot__btn-text">
            {{ reanexoBoleto ? reanexoBoleto.name : 'Selecionar ou arraste aqui' }}
          </span>
          <input
            type="file"
            accept=".pdf,application/pdf"
            (change)="onReanexoFile('boleto', $event)"
            hidden>
        </label>
        <a *ngIf="reanexoBoleto" class="anexo-slot__clear" (click)="clearReanexoFile('boleto')">Remover</a>
      </div>

      <div class="anexo-slot"
           [class.anexo-slot--drag]="reanexoRomaneioDrag"
           (dragover)="onReanexoSlotDragOver($event, 'romaneio')"
           (dragleave)="onReanexoSlotDragLeave($event, 'romaneio')"
           (drop)="onReanexoSlotDrop($event, 'romaneio')">
        <span class="anexo-slot__label">Romaneio (PDF)</span>
        <label class="anexo-slot__btn">
          <span class="po-icon an an-paperclip"></span>
          <span class="anexo-slot__btn-text">
            {{ reanexoRomaneio ? reanexoRomaneio.name : 'Selecionar ou arraste aqui' }}
          </span>
          <input
            type="file"
            accept=".pdf,application/pdf"
            (change)="onReanexoFile('romaneio', $event)"
            hidden>
        </label>
        <a *ngIf="reanexoRomaneio" class="anexo-slot__clear" (click)="clearReanexoFile('romaneio')">Remover</a>
      </div>
    </div>
  </div>
</po-modal>

<po-page-slide
  #slideFilterAdvanced
  p-size="auto"
  p-title="Filtros Avançados">

<form [formGroup]="filterForm">

  <div class="po-row">
    <po-multiselect
      class="po-xl-3 po-lg-6 po-md-12 po-sm-12"
      formControlName="usuario"
      name="usuario"
      p-label="Usuário"
      p-placeholder="Selecione um ou mais"
      [p-options]="usuarioOptions">
    </po-multiselect>
      <po-select
      class="po-xl-3 po-lg-6 po-md-3 po-sm-12"
        formControlName="status"
        name="status"
        p-label="Status"
        p-placeholder="Selecione"
        [p-options]="statusOptions">
      </po-select>
      <po-select
      class="po-xl-3 po-lg-6 po-md-3 po-sm-12"
      formControlName="tipo"
        name="tipo"
        p-label="Tipo"
        p-placeholder="Selecione"
        [p-options]="tipoOptions">
      </po-select>
      <po-select
      class="po-xl-3 po-lg-6 po-md-3 po-sm-12"
      formControlName="fin"
      name="fin"
        p-label="Financeiro?"
        p-placeholder="Selecione"
        [p-options]="finOptions">
      </po-select>
    </div>

    <div class="po-row">
      <po-input
      class="po-xl-2 po-lg-4 po-md-3 po-sm-12"
      formControlName="numero"
      name="numero"
      p-label="Nº Nota">
    </po-input>
    <po-input
    class="po-xl-2 po-lg-4 po-md-3 po-sm-12"
    formControlName="rps"
    name="rps"
    p-label="Nº RPS">
  </po-input>
    <po-input
    class="po-xl-2 po-lg-4 po-md-3 po-sm-12"
    formControlName="codigo"
    name="codigo"
    p-label="Código">
  </po-input>
      <po-input
        class="po-xl-3 po-lg-4 po-md-3 po-sm-12"
        formControlName="processo"
        name="processo"
        p-label="Processo">
      </po-input>
      <po-input
        class="po-xl-4 po-lg-8 po-md-3 po-sm-12"
        formControlName="fornecedor"
        name="fornecedor"
        p-label="Fornecedor">
      </po-input>
      <po-input
        class="po-xl-1 po-lg-4 po-md-3 po-sm-12"
        formControlName="tes"
        name="tes"
        p-label="TES">
      </po-input>
      <po-select
        class="po-xl-12 po-lg-12 po-md-12 po-sm-12"
        formControlName="tomadorCnpj"
        name="tomadorCnpj"
        p-label="Tomador"
        p-placeholder="Todos"
        [p-options]="tomadorOptions">
      </po-select>
    </div>

    <div class="po-row">
      <po-input
        class="po-xl-6 po-lg-6 po-md-6 po-sm-12"
        formControlName="produto"
        name="produto"
        p-label="Produto">
      </po-input>
      <po-select
      class="po-xl-3 po-lg-3 po-md-3 po-sm-12"
      formControlName="origem"
        name="origem"
        p-label="Origem"
        p-placeholder="Selecione"
        [p-options]="origemOptions">
      </po-select>
      <po-select
        *ngIf="canViewOcultos"
        class="po-xl-3 po-lg-3 po-md-3 po-sm-12"
        formControlName="oculto"
        name="oculto"
        p-label="Oculto"
        p-placeholder="Selecione"
        [p-options]="ocultoOptions">
      </po-select>
      <po-select
        class="po-xl-3 po-lg-3 po-md-3 po-sm-12"
        formControlName="semAnexo"
        name="semAnexo"
        p-label="Anexos"
        p-placeholder="Selecione"
        [p-options]="semAnexoOptions">
      </po-select>
      <po-multiselect
        class="po-xl-3 po-lg-3 po-md-3 po-sm-12"
        formControlName="cnxStatus"
        name="cnxStatus"
        p-label="Conexos"
        p-placeholder="Selecione um ou mais"
        [p-options]="cnxStatusOptions">
      </po-multiselect>
    </div>

    <hr>

    <div class="po-row">
      <po-datepicker
        class="po-xl-3 po-lg-6 po-md-3 po-sm-12"
        formControlName="emissaoDe"
        name="emissaoDe"
        p-clean
        p-label="Data Emissão de">
      </po-datepicker>
      <po-datepicker
        class="po-xl-3 po-lg-6 po-md-3 po-sm-12"
        formControlName="emissaoAte"
        name="emissaoAte"
        p-clean
        p-label="até">
      </po-datepicker>
      <po-datepicker
      class="po-xl-3 po-lg-6 po-md-3 po-sm-12"
      formControlName="recebidaDe"
      name="recebidaDe"
      p-clean
        p-label="Data Recebida de">
      </po-datepicker>
      <po-datepicker
        class="po-xl-3 po-lg-6 po-md-3 po-sm-12"
        formControlName="recebidaAte"
        name="recebidaAte"
        p-clean
        p-label="até">
      </po-datepicker>
    </div>

    <div class="po-row">
      <po-datepicker
      class="po-xl-3 po-lg-6 po-md-3 po-sm-12"
      formControlName="aprovadoDe"
        name="aprovadoDe"
        p-clean
        p-label="Data Aprovação de">
      </po-datepicker>
      <po-datepicker
        class="po-xl-3 po-lg-6 po-md-3 po-sm-12"
        formControlName="aprovadoAte"
        name="aprovadoAte"
        p-clean
        p-label="até">
      </po-datepicker>
      <po-datepicker
        class="po-xl-3 po-lg-6 po-md-3 po-sm-12"
        formControlName="vencimentoDe"
        name="vencimentoDe"
        p-clean
        p-label="Data Vencimento de">
      </po-datepicker>
      <po-datepicker
      class="po-xl-3 po-lg-6 po-md-3 po-sm-12"
      formControlName="vencimentoAte"
      name="vencimentoAte"
        p-clean
        p-label="até">
      </po-datepicker>
    </div>

    <div class="po-row">
      <po-decimal
        class="po-xl-3 po-lg-6 po-md-6 po-sm-12"
        formControlName="totalDe"
        name="totalDe"
        p-label="Valor Total de">
      </po-decimal>
      <po-decimal
        class="po-xl-3 po-lg-6 po-md-6 po-sm-12"
        formControlName="totalAte"
        name="totalAte"
        p-label="até">
      </po-decimal>
    </div>

  </form>

  <div class="po-row" style="margin-top: 16px;">
    <div class="po-xl-12" style="display: flex; gap: 8px; justify-content: flex-end;">
      <po-button
        p-icon="an an-funnel-x"
        p-label="Limpar Filtros"
        [p-disabled]="!hasActiveFilters"
        (p-click)="clearAdvancedFilter()">
      </po-button>
      <po-button
        p-label="Cancelar"
        p-kind="secondary"
        p-danger="true"
        (p-click)="cancelAdvancedFilter()">
      </po-button>
      <po-button
        p-label="Confirmar"
        p-kind="primary"
        (p-click)="confirmAdvancedFilter()">
      </po-button>
    </div>
  </div>

</po-page-slide>
